// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200933/js/" + chunkId + "." + {"44":"22df6335","225":"5b12f5b9","481":"8c7e21bc","486":"81a9ec56","770":"f8d45d02"}[chunkId] + ".0.23206188677799688.chunk.js";
};